import { createContext } from 'react';

import type { LiveLogContextValue } from './LiveLog.types';

// eslint-disable-next-line import/prefer-default-export
export const LiveLogContext = createContext<LiveLogContextValue>({
  announce: () => {},
  announcePolite: () => {},
  announceAssertive: () => {},
  initialized: false
});
